import { render, staticRenderFns } from "./entity-notifications.vue?vue&type=template&id=4bfc5950"
import script from "./entity-notifications.vue?vue&type=script&lang=js"
export * from "./entity-notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports